export const UserEndpoints = {
  userProfile: () => 'aluno/perfil',
};
